import React, { Component } from 'react';
import { connect } from 'react-redux';

import { currentProjectIdSelector } from '../../../reducers/projects';
import { wbsRelTypeIdSelector } from '../../../reducers/relationshipTypes';
import { relationshipsByType, relationshipsSelector } from '../../../reducers/relationships';
import { currentUserSelector, getUserModeByProjectId } from '../../../reducers/users';
import { buildFlatListNew } from '../../../reducers/views';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import NoElements from '../../../components/states/NoElements';
import ElementsByTypeTab from './ElementsByType';
import {hashHistory} from "react-router";


const sortTypeSelector = (state, props) => props.sortType;

const sortBySelector = (state, props) => props.sortBy;

const filterTypeSelector = (state, props) => props.filterType;

const taskTypeIdSelector = (state, props) => props.taskTypeId;

const elementTypeSelector = (state, props) => props.elementType;

const elementTypesSelector = (state, props) => props.elementTypes;

const elementTypeIdSelector = (state, props) => props.elementTypeId;

const filteredElementsSelector = (state, props) => props.filteredElements;

const elementsSelector = (state, props) => props.elements;

const orderedWbsElementsSelector = (state, props) => {
  return props.elementType.get('id') === props.taskTypeId ? props.orderedWbsElements : [];
}

const ElementsByTypeSelector = immutableCreatorSelector(
  [
    elementTypeSelector,
    elementTypesSelector,
    currentProjectIdSelector,
    filteredElementsSelector,
    elementsSelector,
    relationshipsSelector,
    currentUserSelector,
    taskTypeIdSelector,
    sortTypeSelector,
    sortBySelector,
    filterTypeSelector,
    orderedWbsElementsSelector,
    wbsRelTypeIdSelector,
    elementTypeIdSelector,
  ],
  (
    elementType,
    elementTypes,
    currentProjectId,
    filteredElements,
    elements,
    relationships,
    currentUser,
    taskTypeId,
    sortType,
    sortBy,
    filterType,
    orderedWbsElements,
    wbsRelTypeId,
    elementTypeId,
  ) => {
    return {
      currentProjectId,
      relationshipsMapping: relationshipsByType(relationships),
      currentUser,
      flatList: buildFlatListNew(
        orderedWbsElements,
        elements,
        filteredElements,
        relationshipsByType(relationships),
        wbsRelTypeId,
        sortBy,
        filterType,
        currentUser,
      ),
      orderedWbsElements,
      taskTypeBool: elementTypeId === taskTypeId,
      elementTypes,
      userMode: getUserModeByProjectId(currentUser, currentProjectId),
    };
  }
);

@connect(ElementsByTypeSelector)
export default
class ElementsByTypeContainer extends Component {

  onElementSelected = (element) => {
    const elementId = element ? element.get('id') : null;
    const previouslySelectedElementId = this.props.location.hash.split("selected-element=")[1] || null;
    if (!previouslySelectedElementId || elementId){
      const locationHash = elementId ? `selected-element=${elementId}` : ''
      hashHistory.replace(locationHash);
    }
    if (previouslySelectedElementId && !elementId){
      hashHistory.replace('');
    }
  }

  render() {
    const { orderedWbsElements, filteredElements, taskTypeBool } = this.props;

    if (!filteredElements.size && orderedWbsElements && !orderedWbsElements.length) {
      const noElements = taskTypeBool ? 'work breakdown structure elements or tasks' : 'elements';
      return <NoElements missingEntity={noElements} />;
    }

    return <ElementsByTypeTab {...this.props} onElementSelected={this.onElementSelected}/>;
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/ElementsByType/ElementsByTypeContainer.js